export enum BarcodeTypeId {
  auspost = 'auspost',
  azteccode = 'azteccode',
  azteccodecompact = 'azteccodecompact',
  aztecrune = 'aztecrune',
  bc412 = 'bc412',
  channelcode = 'channelcode',
  codablockf = 'codablockf',
  code11 = 'code11',
  code128 = 'code128',
  code16k = 'code16k',
  code2of5 = 'code2of5',
  code32 = 'code32',
  code39 = 'code39',
  code39ext = 'code39ext',
  code49 = 'code49',
  code93 = 'code93',
  code93ext = 'code93ext',
  codeone = 'codeone',
  coop2of5 = 'coop2of5',
  daft = 'daft',
  databarexpanded = 'databarexpanded',
  databarexpandedcomposite = 'databarexpandedcomposite',
  databarexpandedstacked = 'databarexpandedstacked',
  databarexpandedstackedcomposite = 'databarexpandedstackedcomposite',
  databarlimited = 'databarlimited',
  databarlimitedcomposite = 'databarlimitedcomposite',
  databaromni = 'databaromni',
  databaromnicomposite = 'databaromnicomposite',
  databarstacked = 'databarstacked',
  databarstackedcomposite = 'databarstackedcomposite',
  databarstackedomni = 'databarstackedomni',
  databarstackedomnicomposite = 'databarstackedomnicomposite',
  databartruncated = 'databartruncated',
  databartruncatedcomposite = 'databartruncatedcomposite',
  datalogic2of5 = 'datalogic2of5',
  chinapost = 'chinapost',
  datamatrix = 'datamatrix',
  datamatrixrectangular = 'datamatrixrectangular',
  datamatrixrectangularextension = 'datamatrixrectangularextension',
  dotcode = 'dotcode',
  ean2 = 'ean2',
  ean5 = 'ean5',
  ean8 = 'ean8',
  ean8composite = 'ean8composite',
  ean13 = 'ean13',
  // ean = 'ean13',
  ean13composite = 'ean13composite',
  ean14 = 'ean14',
  flattermarken = 'flattermarken',
  gs1_128 = 'gs1_128',
  gs1_128composite = 'gs1_128composite',
  gs1_cc = 'gs1_cc',
  gs1datamatrix = 'gs1datamatrix',
  gs1datamatrixrectangular = 'gs1datamatrixrectangular',
  gs1dotcode = 'gs1dotcode',
  gs1northamericancoupon = 'gs1northamericancoupon',
  gs1qrcode = 'gs1qrcode',
  hanxin = 'hanxin',
  hibcazteccode = 'hibcazteccode',
  hibccodablockf = 'hibccodablockf',
  hibccode128 = 'hibccode128',
  hibccode39 = 'hibccode39',
  hibcdatamatrix = 'hibcdatamatrix',
  hibcdatamatrixrectangular = 'hibcdatamatrixrectangular',
  hibcmicropdf417 = 'hibcmicropdf417',
  hibcpdf417 = 'hibcpdf417',
  hibcqrcode = 'hibcqrcode',
  iata2of5 = 'iata2of5',
  identcode = 'identcode',
  industrial2of5 = 'industrial2of5',
  interleaved2of5 = 'interleaved2of5',
  isbn = 'isbn',
  ismn = 'ismn',
  issn = 'issn',
  itf14 = 'itf14',
  jabcode = 'jabcode',
  japanpost = 'japanpost',
  kix = 'kix',
  leitcode = 'leitcode',
  mailmark = 'mailmark',
  matrix2of5 = 'matrix2of5',
  maxicode = 'maxicode',
  micropdf417 = 'micropdf417',
  microqrcode = 'microqrcode',
  msi = 'msi',
  onecode = 'onecode',
  pdf417 = 'pdf417',
  pdf417compact = 'pdf417compact',
  pharmacode = 'pharmacode',
  pharmacode2 = 'pharmacode2',
  planet = 'planet',
  plessey = 'plessey',
  posicode = 'posicode',
  postnet = 'postnet',
  pzn = 'pzn',
  qrcode = 'qrcode',
  rationalizedCodabar = 'rationalizedCodabar',
  raw = 'raw',
  rectangularmicroqrcode = 'rectangularmicroqrcode',
  royalmail = 'royalmail',
  sscc18 = 'sscc18',
  swissqrcode = 'swissqrcode',
  symbol = 'symbol',
  telepen = 'telepen',
  telepennumeric = 'telepennumeric',
  ultracode = 'ultracode',
  upca = 'upca',
  upcacomposite = 'upcacomposite',
  upce = 'upce',
  upcecomposite = 'upcecomposite'
}

export const TwoDimensionalBarcodes = [
  BarcodeTypeId.azteccode,
  BarcodeTypeId.azteccodecompact,
  BarcodeTypeId.aztecrune,
  BarcodeTypeId.hibcazteccode,

  BarcodeTypeId.datamatrix,
  BarcodeTypeId.datamatrixrectangular,
  BarcodeTypeId.datamatrixrectangularextension,
  BarcodeTypeId.gs1datamatrix,
  BarcodeTypeId.gs1datamatrixrectangular,
  BarcodeTypeId.hibcdatamatrix,
  BarcodeTypeId.hibcdatamatrixrectangular,

  BarcodeTypeId.hibcmicropdf417,
  BarcodeTypeId.hibcpdf417,
  BarcodeTypeId.micropdf417,
  BarcodeTypeId.pdf417,
  BarcodeTypeId.pdf417compact,

  BarcodeTypeId.maxicode,

  BarcodeTypeId.databarexpanded,
  BarcodeTypeId.databarexpandedcomposite,
  BarcodeTypeId.databarexpandedstacked,
  BarcodeTypeId.databarexpandedstackedcomposite,

  BarcodeTypeId.databarlimited,
  BarcodeTypeId.databarlimitedcomposite,
  BarcodeTypeId.databaromni,
  BarcodeTypeId.databaromnicomposite,
  BarcodeTypeId.databarstacked,
  BarcodeTypeId.databarstackedcomposite,
  BarcodeTypeId.databarstackedomni,
  BarcodeTypeId.databarstackedomnicomposite,
  BarcodeTypeId.databartruncated,
  BarcodeTypeId.databartruncatedcomposite,

  BarcodeTypeId.dotcode,

  BarcodeTypeId.qrcode,
  BarcodeTypeId.microqrcode,
  BarcodeTypeId.rectangularmicroqrcode,
  BarcodeTypeId.swissqrcode,
  BarcodeTypeId.ultracode,

  BarcodeTypeId.symbol
]

export const OneDimensionalBarcodes = [
  BarcodeTypeId.auspost,
  BarcodeTypeId.bc412,
  BarcodeTypeId.channelcode,
  BarcodeTypeId.codablockf,
  BarcodeTypeId.code11,
  BarcodeTypeId.code128,
  BarcodeTypeId.code16k,
  BarcodeTypeId.code2of5,
  BarcodeTypeId.code32,
  BarcodeTypeId.code39,
  BarcodeTypeId.code39ext,
  BarcodeTypeId.code49,
  BarcodeTypeId.code93,
  BarcodeTypeId.code93ext,
  BarcodeTypeId.codeone,
  BarcodeTypeId.coop2of5,
  BarcodeTypeId.daft,
  BarcodeTypeId.ean2,
  BarcodeTypeId.ean5,
  BarcodeTypeId.ean8,
  BarcodeTypeId.ean8composite,
  BarcodeTypeId.ean13,
  BarcodeTypeId.ean13composite,
  BarcodeTypeId.ean14,
  BarcodeTypeId.flattermarken,
  BarcodeTypeId.gs1_128,
  BarcodeTypeId.gs1_128composite,
  BarcodeTypeId.gs1_cc,
  BarcodeTypeId.gs1dotcode,
  BarcodeTypeId.gs1northamericancoupon,
  BarcodeTypeId.gs1qrcode,
  BarcodeTypeId.hanxin,
  BarcodeTypeId.hibccodablockf,
  BarcodeTypeId.hibccode128,
  BarcodeTypeId.hibccode39,
  BarcodeTypeId.datalogic2of5,
  BarcodeTypeId.hibcqrcode,
  BarcodeTypeId.iata2of5,
  BarcodeTypeId.identcode,
  BarcodeTypeId.industrial2of5,
  BarcodeTypeId.interleaved2of5,
  BarcodeTypeId.isbn,
  BarcodeTypeId.ismn,
  BarcodeTypeId.issn,
  BarcodeTypeId.itf14,
  BarcodeTypeId.jabcode,
  BarcodeTypeId.japanpost,
  BarcodeTypeId.kix,
  BarcodeTypeId.leitcode,
  BarcodeTypeId.mailmark,
  BarcodeTypeId.matrix2of5,
  BarcodeTypeId.msi,
  BarcodeTypeId.onecode,
  BarcodeTypeId.pharmacode,
  BarcodeTypeId.pharmacode2,
  BarcodeTypeId.planet,
  BarcodeTypeId.plessey,
  BarcodeTypeId.posicode,
  BarcodeTypeId.postnet,
  BarcodeTypeId.pzn,
  BarcodeTypeId.rationalizedCodabar,
  BarcodeTypeId.raw,
  BarcodeTypeId.royalmail,
  BarcodeTypeId.sscc18,
  BarcodeTypeId.telepen,
  BarcodeTypeId.telepennumeric,
  BarcodeTypeId.upca,
  BarcodeTypeId.upcacomposite,
  BarcodeTypeId.upce,
  BarcodeTypeId.upcecomposite
]

export default {
  BarcodeTypeId,
  Types: {
    OneDimensional: OneDimensionalBarcodes,
    TwoDimensional: TwoDimensionalBarcodes
  }
}